import { getLocale } from '@/locales/locale';
import { Box } from '@fpxfd/next';
import { BoxProps } from '@fpxfd/next/types/box';
import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';

interface Props extends BoxProps {
  children: React.ReactNode;
}

const FitScreenBox = ({ children }: Props) => {
  const [lang, setLang] = useState<Boolean>(false);

  useEffect(() => {
    const str: string = getLocale() || '';
    if (str?.includes('ru') || str?.includes('es')) {
      setLang(true);
    } else {
      setLang(false);
    }
  }, []);

  return (
    <Box
      justify="flex-end"
      direction="row"
      align="flex-end"
      flex={1}
      className={`${styles.fitScreenBox} limitInnerBox ${lang ? 'overStyle' : ''}`}
      style={{ marginTop: '16px' }}
    >
      {children}
    </Box>
  );
};

export default FitScreenBox;
